import { SUPPORTED_MIMETYPES } from '../constants';

const CLIENT_ID =
  '896434730160-qetmsgnuu1vmrk1akhjldniade1s4l0k.apps.googleusercontent.com';
const i18n = require('../i18n');

let inited;

export function init(cb) {
  if (!window.google) {
    return setTimeout(() => init(cb), 1000);
  }
  window.google.accounts.id.initialize({
    client_id: CLIENT_ID,
    callback: cb,
  });
  inited = true;
}

export function renderButton({ width = 'large', text = 'continue_with' }) {
  if (!window.google || !inited) {
    return setTimeout(() => renderButton({ width, text }), 1000);
  }

  window.google.accounts.id.renderButton(
    document.getElementById('googleButtonDiv'),
    {
      theme: 'outline',
      size: 'large',
      width,
      locale: i18n.language,
      text,
    }
  );
  return true;
}

const clientId =
  '896434730160-avakjff4mf9gtei8n6fqdev6i6pt1gvd.apps.googleusercontent.com';
const drive_scope = ['https://www.googleapis.com/auth/drive.file'];
const drive_discovery = [
  'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
];
const appId = 'klang-oauth';
let oauthToken;
let idToken;
let pickerApiLoaded = false;
let refreshCode = null;

export function login(
  scope = drive_scope,
  discoveryDocs = drive_discovery,
  offline = false
) {
  return new Promise((resolve, reject) => {
    function handleAuthResult(authResult, refreshCode) {
      if (authResult && !authResult.error) {
        oauthToken = authResult.access_token;
        idToken = authResult.id_token;
        resolve({ oauthToken, refreshCode });
      } else reject(authResult.error);
    }

    function onAuthApiLoad() {
      scope = scope.concat(['profile']);
      console.log('auth api load', {
        clientId,
        scope: scope.join(' '),
        discoveryDocs,
      });
      window.gapi.client
        .init({
          clientId,
          scope: scope.join(' '),
          discoveryDocs,
        })
        .then(async () => {
          const authInstance = window.gapi.auth2.getAuthInstance();
          if (offline) {
            const { code } = await authInstance.grantOfflineAccess({
              redirect_uri: 'postmessage',
              approval_prompt: 'force',
            });

            if (code) {
              refreshCode = code;
            }
          } else {
            await authInstance.signIn();
          }
          const res = authInstance.currentUser.get().getAuthResponse();
          handleAuthResult(res, refreshCode);
        })
        .catch(reject);
    }

    window.gapi.load('client', { callback: onAuthApiLoad });
  });
}

export function getIdToken() {
  return idToken;
}

export function getProfile() {
  if (!idToken) return {};
  let profile = window.gapi.auth2
    .getAuthInstance()
    .currentUser.get()
    .getBasicProfile();
  return {
    email: profile.getEmail(),
    token: idToken,
  };
}

export async function showPicker(onUpload, history, onFileOptions) {
  function onPickerApiLoad() {
    pickerApiLoaded = true;
    createPicker();
  }

  function createPicker() {
    let google = window.google;
    if (pickerApiLoaded && oauthToken) {
      // Add a new view to the picker, we allow videos and audio files
      var view = new google.picker.View(google.picker.ViewId.DOCS);
      view.setMimeTypes(SUPPORTED_MIMETYPES.join(','));
      var picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .enableFeature(google.picker.Feature.MULTISELECT_DISABLED)
        .setAppId(appId)
        .setOAuthToken(oauthToken)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setCallback(pickerCallback)
        .build();
      picker.setVisible(true);
    }
  }

  function pickerCallback(data) {
    let google = window.google;
    if (data.action === google.picker.Action.PICKED) {
      console.log('DATA IS', data, google.picker, google, oauthToken);
      const { id: fileId, name: fileName, type } = data.docs[0];

      async function onExportOk({ body, headers, ...rest }) {
        const size = parseInt(headers['content-length'], 10);
        console.log('EXPORT OK', 'size', size);
      }

      async function onDownloadOk(res) {
        const { body, headers } = res;
        const contentArray = new Array(body.length);
        for (let i = 0; i < contentArray.length; i++) {
          contentArray[i] = body.charCodeAt(i);
        }
        const byteArray = new Uint8Array(contentArray);
        const blob = new Blob([byteArray], { type: headers['Content-Type'] });
        const formData = new FormData();
        formData.append('file', blob, fileName);
        formData.append('name', fileName);

        const s = fileName.split('.');
        const fileType = s[s.length - 1];
        onFileOptions(formData, fileName, fileType);
      }

      function onError(e) {
        console.error(e);
      }

      if (type === 'document') {
        window.gapi.client.drive.files
          .export({
            // Read more about export at https://developers.google.com/drive/v3/reference/files/export#http-request
            fileId,
            mimeType: 'text/csv',
          })
          .then(onExportOk, onError);
        onUpload(true, fileName);
      } else {
        onUpload(true, { fileId, fileName, oauthToken });
      }
    } else if (data.action === google.picker.Action.CANCEL) {
      onUpload(false);
    }
  }

  if (oauthToken && pickerApiLoaded) {
    createPicker();
  } else {
    console.log('Loggin in');
    await login();
    console.log('CREATING PICKER');
    createPicker();
    window.gapi.load('picker', { callback: onPickerApiLoad });
  }
}
